export const HEIGHT_CSS_PROPERTY = 'height';
